import * as React from "react";
import { useEffect } from 'react';
import {
  ContentPage, IPageContent,
  IPageContentArticle,
  IPageContentImage,
  TContentState,
} from '../types/Content';
import { useCMS } from "../hooks/useCMS";
import Paragraph from "./cms/Paragraph";
import Expansion from "./cms/Expansion";
import Image from "./cms/Image";
import CmsCard from "./cms/CmsCard";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle } from "../actions/ContentActions";
import { IAppState } from "../store/Store";
import FavoriteIcons from './cms/FavoriteIcons';
import { isEmpty } from 'lodash';

interface IPageContentProps {
  pageType: ContentPage | null;
  pageId?: number;
  showAsParagraph?: boolean;
  showAsCard?: boolean;
  customTitle?: string;
  hideContent?: boolean;
  frontpageList?: IPageContent[];
  beforeFavorites?: React.ReactNode;
}

const PageContent: React.FC<IPageContentProps> = props => {
  const { cms } = useCMS(props.pageType, props.pageId);
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState<string | false>("panel0");
  const contentState: TContentState = useSelector<IAppState, TContentState>(
    state => state.contentState
  );

  const customTitle = props.customTitle;

  const handleChange = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (customTitle) {
      dispatch(setCurrentPageTitle(customTitle));
      return;
    }

    let isCurrentPageData = false;
    if (props.pageId) {
      isCurrentPageData = contentState.data?.id === props.pageId;
    } else if (props.pageType) {
      isCurrentPageData = contentState.data?.type === props.pageType;
    }

    if (isCurrentPageData && contentState.data?.name) {
      dispatch(setCurrentPageTitle(contentState.data.name));
    }
  }, [dispatch, contentState.data?.id, contentState.data?.type, contentState.data?.name, customTitle, props.pageType, props.pageId]);

  //TODO: Rework this to use react-query
  if (props.hideContent) {
    return null;
  }

  return (
    <>
      {cms.getPageImages()?.map((image: IPageContentImage, index: number) => {
        if (image.url) {
          return <Image image={image} key={index} />;
        }

        return false;
      })}
      {props.beforeFavorites}
      {props.frontpageList && !isEmpty(props.frontpageList) && (
        <FavoriteIcons frontpageList={props.frontpageList}/>
      )}
      {cms
        .getPageContent()
        ?.map((article: IPageContentArticle, index: number) => {
          if (props.showAsParagraph) {
            return <Paragraph key={index} body={article.bodyText} />;
          }
          if (props.showAsCard) {
            return (
              <CmsCard
                key={index}
                headline={article.headline}
                bodyText={article.bodyText}
              />
            );
          }
          return (
            <Expansion
              headline={article.headline}
              bodyText={article.bodyText}
              index={index}
              expanded={expanded}
              handleChange={handleChange}
            />
          );
        })}
    </>
  );
};

export default PageContent;
